



















































import { Vue, Component, VModel, Watch, Prop } from 'vue-property-decorator';

import { SelectOptionData } from "../../../components/Pi/types";
import PiDropdownInput from "../../../components/PiDropdownInput.vue";
import { RecordValue } from '../../types/HttpRequest';
import { IterableItemFactory, IterableListItem } from "../../utils/IterableItemFactory";

@Component({
  components: {
    PiDropdownInput
  }
})
export default class RecordFillFields extends Vue {
  @VModel({ type: Object, required: true }) record!: Record<string, string>

  @Prop({ type: Array, default: () => [], required: false }) keyOptions!: Array<SelectOptionData | string>

  @Prop({ type: Function, default: () => [], required: false }) valueOptions!: (key: string) => Array<SelectOptionData | string>

  @Prop({ type: String }) addButtonTitle!: string

  @Prop({ type: String, required: false, default: "Name" }) keyPlaceholder!: string

  @Prop({ type: String, required: false, default: "Value" }) valuePlaceholder!: string

  iterableItemFactory = new IterableItemFactory()

  stateValue: Array<IterableListItem<RecordValue>> = []

  @Watch('stateValue', { deep: true })
  onStateValueChange(localHeaders: Array<IterableListItem<RecordValue>>) {
    this.record = localHeaders.reduce((acc: Record<string, string>, item) => {
      const { key, value } = item.value
      const trimKey = key.trim()

      acc[trimKey] = value.trim()

      return acc
    }, {})
  }

  removeRecord(guid: string) {
    this.stateValue = this.stateValue.filter(v => v.guid !== guid)
  }

  getHeaderValueOptions(key: string) {
    return this.valueOptions(key)
  }

  addRecord() {
    this.stateValue.push(this.iterableItemFactory.create({
      key: '',
      value: ''
    }))
  }

  created() {
    this.stateValue = Object.entries((this.record ?? {})).map(([ key, value ]) => this.iterableItemFactory.create({ key, value }))
  }
}
